var exports = {
  "e": "xae11d333--8c1a36--bottom-content",
  "F": "xae11d333--8c1a36--factoid",
};

module.exports = exports;
